import { UserRole } from "@packages/store/types";

import { IconType } from "@/components/Icon";
import { ROUTES } from "@/routes";

export const LANGUAGE_KEY = "lang";
export const DEFAULT_LANGUAGE = "ru";

export const EXERCISE_IMG_PLUG = "/img/course-preview.jpg";
export const UNIT_IMG_PLUG = "/img/unit-preview.jpg";
export const UNIT_IMG_1_PLUG = "/img/unit-preview-1.jpg";
export const UNIT_IMG_2_PLUG = "/img/unit-preview-2.jpg";

export const languages = [
  {
    code: "ru",
    title: "RUS",
  },
  {
    code: "en",
    title: "ENG",
  },
  {
    code: "uz",
    title: "UZB",
  },
  {
    code: "ur",
    title: "URD",
  },
  {
    code: "ar",
    title: "AR",
  },
  {
    code: "es",
    title: "ES",
  },
  {
    code: "pt",
    title: "PT",
  },
  {
    code: "zh",
    title: "ZH",
  },
];

export const PROMOCODE_KEY = "jetclass_promocode";

type MenuItem = {
  path: ROUTES;
  title: string;
  icon: IconType;
  disabled?: boolean;
};

export const authRoutes = [
  ROUTES.AUTH,
  ROUTES.REGISTER,
  ROUTES.RESET,
  ROUTES.EDIT_PASSWORD,
  ROUTES.PROMOCODE_EXPIRED,
];

const allMenuItems = {
  home: {
    path: ROUTES.HOME,
    title: "Menu:Main",
    icon: "menu-main",
  },
  words: {
    path: ROUTES.WORDS,
    title: "Menu:Words",
    icon: "menu-lexis",
  },
  courses: {
    path: ROUTES.COURSES,
    title: "Menu:Courses",
    icon: "menu-courses",
  },
  lessons: {
    path: ROUTES.LESSONS,
    title: "Menu:Lessons",
    icon: "menu-lessons",
  },
  attendance: {
    path: ROUTES.ATTENDANCE,
    title: "Menu:Attendance",
    icon: "menu-attendance",
  },
  usefulLinks: {
    path: ROUTES.USEFUL_LINKS,
    title: "Menu:UsefulLinks",
    icon: "menu-links",
  },
  creativeTasks: {
    path: ROUTES.CREATIVE_TASKS,
    title: "Menu:CreativeTasks",
    icon: "menu-teacher",
  },
  groups: {
    path: ROUTES.GROUPS,
    title: "Menu:TeacherGroups",
    icon: "menu-groups",
  },
  reports: {
    path: ROUTES.REPORTS,
    title: "Menu:TeacherReports",
    icon: "menu-video",
  },
} as const;

export const menuItems: Partial<Record<UserRole, MenuItem[]>> = {
  [UserRole.STUDENT]: [
    allMenuItems.home,
    allMenuItems.words,
    allMenuItems.courses,
    allMenuItems.lessons,
    allMenuItems.usefulLinks,
    allMenuItems.creativeTasks,
  ],
  [UserRole.TEACHER]: [
    allMenuItems.home,
    allMenuItems.courses,
    allMenuItems.creativeTasks,
    allMenuItems.reports,
    allMenuItems.lessons,
    allMenuItems.groups,
    allMenuItems.attendance,
  ],
  [UserRole.DISTRIBUTOR]: [
    allMenuItems.home,
    allMenuItems.courses,
    allMenuItems.reports,
    allMenuItems.groups,
    allMenuItems.attendance,
  ],
  [UserRole.COORDINATOR]: [
    allMenuItems.home,
    allMenuItems.courses,
    allMenuItems.reports,
    allMenuItems.groups,
    allMenuItems.attendance,
  ],
};

export const rolePagePermissions = Object.fromEntries(
  Object.entries(menuItems).map(([role, item]) => [
    role as UserRole,
    item.flatMap(({ path }) => path),
  ]),
) as Record<UserRole, ROUTES[]>;

const grantPermissions = (
  roles: UserRole | UserRole[],
  pages: ROUTES | ROUTES[],
) => {
  if (!Array.isArray(roles)) roles = [roles];
  if (!Array.isArray(pages)) pages = [pages];

  roles.forEach((role) => {
    rolePagePermissions[role].push(...(pages as ROUTES[]));
  });
};

grantPermissions(UserRole.TEACHER, ROUTES.COURSES); // У преподавателя нет страницы всех курсов но на отдельный он перейти может
grantPermissions(UserRole.STUDENT, [
  ROUTES.SETUP_PASSWORD,
  ROUTES.STUDENT_CONFIRM_EMAIL,
]);
grantPermissions(
  [
    UserRole.STUDENT,
    UserRole.TEACHER,
    UserRole.DISTRIBUTOR,
    UserRole.COORDINATOR,
  ],
  ROUTES.PROFILE,
);
